import WordWheelApi from "./api";

/**
 * Load the puzzle for a screenshot scene.
 * `tplId` loads that published template. Otherwise `journeyLevel` loads the season catalog.
 * @param {{ journeyLevel?: number, season?: string, tplId?: string }} scene
 */
export async function loadScreenshotWordWheel(scene) {
    const tplId = typeof scene?.tplId === "string" ? scene.tplId.trim() : "";
    const level = Number(scene?.journeyLevel);
    if (!tplId && (!Number.isFinite(level) || level < 1)) {
        throw new Error("journeyLevel is required for word wheel screenshot scenes");
    }
    try {
        const data = tplId
            ? await WordWheelApi.fetchPublishedById(tplId)
            : await WordWheelApi.fetchJourneyLevel(level, scene?.season);
        if (data?.code === "NO_DATA") {
            throw new Error(
                tplId
                    ? `No published word wheel for template ${tplId}`
                    : `No puzzle found for season ${scene?.season || "season_2026"} at level ${level}`,
            );
        }
        return data;
    } catch (e) {
        if (e?.status === 404) {
            throw new Error(
                "Screenshot API unavailable (404). Restart puzzle-be so GET /v1/puzzle/wordwheel/journey is registered."
            );
        }
        throw e;
    }
}
